module.exports = __webpack_public_path__ + "static/WhatsApp Image 2020-09-07 at 3.53.03 PM (4)-c279f5c14e3aab78be1ef315cf60750d.jpeg";